import {
    DownloadIcon,
    EyeIcon,
    PencilIcon,
    PlusIcon,
    SyncIcon,
    UploadIcon
} from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Text } from "@primer/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { importHistoryApi } from "../../api/importHistoryApi";
import DataGrid from "../../components/data-grid";
import { IDataGridColumn } from "../../components/data-grid/type/IDataGridProps";
import TextWithEllipse from "../../components/text-with-ellipse";
import Button from '../../components/ui/button';
import { sf_import_history_request } from "../../models/request/import-history/sf_import_history_request";
import { sf_import_history } from "../../models/response/import-history/sf_import_history";
import { RootState } from '../../state/reducers';
import { ImportHachToanModal } from "../hach-toan-cong-no/import-modal";
import { HoanPhiImportModal } from "../tong-hop/import-hoanphi/HoanPhiImportModal";
import { KhoanNopImportModal } from "../tong-hop/import-khoannop/KhoanNopImportModal";
import { KhoanNopImportModalV3 } from "../tong-hop/import-khoannop/KhoanNopImportModalV3";
import { KhoanThuImportModal } from "../tong-hop/import-khoanthu/KhoanThuImportModal";
import DetailModal from "./DetailModal";
import EditKhoanNopModal from "./EditKhoanNopModal";

const ImportHistoryPage: React.FC = () => {
    const [importHistorys, setImportHistorys] = useState<sf_import_history[]>([]);
    const { nam_hoc: param_nam_hoc, dm_coso_id } = useSelector(
        (x: RootState) => x.common
    );
    const [isShowPreview, setIsShowPreview] = useState<boolean>(false);
    const [request, setRequest] = useState<any>([]);
    const [dataPreview, setDataPreview] = useState<any>([]);
    const [isShowImportKhoanThuModal, setIsShowImportKhoanThuModal] = useState(false);
    const [isShowImportKhoanNopModal, setIsShowImportKhoanNopModal] = useState(false);
    const [isShowImportKhoanNopV3Modal, setIsShowImportKhoanNopV3Modal] = useState(false);
    const [isShowImportQuyetToanModal, setIsShowImportQuyetToanModal] = useState(false);
    const [isShowImportHoanPhiModal, setIsShowImportHoanPhiModal] = useState(false);
    const [isShowEditKhoanNopModal, setIsShowEditKhoanNopModal] = useState(false);

    useEffect(() => {
        handleReloadImportHistorys();
    }, []);

    const handleReloadImportHistorys = async () => {
        const res = await importHistoryApi.selectAll();
        if (res.is_success) {
            setImportHistorys(res.data);
        }
    };

    const handleRefresh = () => {
        handleReloadImportHistorys();
    };

    const btnEditDataRender_click = (data: sf_import_history) => {
        const dataRequest: sf_import_history_request = { import_menu: 'Import khoản nộp', sf_import_hitory_id: data.id };
        setRequest(dataRequest);
        setIsShowEditKhoanNopModal(true);
    };

    const btnPreview_click = (data: sf_import_history) => {
        handleReloadPreviewData(data);
        setIsShowPreview(true);
    };

    const handleShowImportKhoanThu = () => {
        setIsShowImportKhoanThuModal(true);
    };

    const handleShowImportKhoanNop = () => {
        setIsShowImportKhoanNopModal(true);
    };

    const handleShowImportKhoanNopNew = () => {
        setIsShowImportKhoanNopV3Modal(true);
    };

    const handleShowImportHoanPhi = () => {
        setIsShowImportHoanPhiModal(true);
    };

    const handleShowImportQuyetToan = () => {
        setIsShowImportQuyetToanModal(true);
    };

    const handleReloadPreviewData = async (data: any) => {
        const res = await importHistoryApi.read_import_file(data.url);
        if (res.is_success) {
            setDataPreview(res.data);
        }
    };

    // Columns cho DataGrid
    const columns: IDataGridColumn[] = [
        {
            dataField: "nam_hoc",
            caption: "Năm học",
            width: 100,
        },
        {
            dataField: "import_menu",
            caption: "Chức năng",
            width: 150,
            cellRender: (rowData) => {
                let color = "";
                if (rowData.import_menu === "Import khoản nộp") {
                    color = "#0b912cff";
                } else if (rowData.import_menu === "Import quyết toán") {
                    color = "#1708DB";
                }
                else {
                    color = "#1708DB";
                }
                return (
                    <Box sx={{ color, display: "flex", alignItems: "center" }}>
                        <Box
                            sx={{
                                height: "7px",
                                width: "7px",
                                backgroundColor: color,
                                borderRadius: "50%",
                                display: "inline-block",
                                mr: 1,
                            }}
                        />
                        {rowData.import_menu}
                    </Box>
                );
            },
        },
        {
            dataField: "file_name",
            caption: "Tên file",
            width: 200,
            cellRender: (rowData) => (
                <TextWithEllipse text={rowData.file_name} lineNumber={1} />
            ),
        },
        {
            dataField: "url",
            caption: "View data",
            width: 100,
            align: "center",
            cellRender: (rowData) => (
                <Box
                    sx={{ cursor: "pointer", color: "#0b912cff" }}
                    onClick={() => btnEditDataRender_click(rowData)}
                >
                    <PencilIcon size={20} />
                </Box>
            ),
        },
        {
            dataField: "url",
            caption: "View file",
            width: 100,
            align: "center",
            cellRender: (rowData) => (
                <Box
                    sx={{ cursor: "pointer", color: "#0B78E5" }}
                    onClick={() => btnPreview_click(rowData)}
                >
                    <EyeIcon size={20} />
                </Box>
            ),
        },
        {
            dataField: "import_fullname",
            caption: "Người import",
            width: 150,
            align: "center",
        },
        {
            dataField: "import_date",
            caption: "Ngày import",
            width: 180,
            cellRender: (rowData) => (
                <Box>
                    {rowData.import_date ? moment(rowData.import_date).format("DD/MM/YYYY HH:mm:ss") : ""}
                </Box>
            ),
        },
        {
            caption: "Tải file",
            width: 80,
            align: "center",
            cellRender: (rowData) => (
                <Box
                    sx={{ cursor: "pointer", color: "#0B78E5" }}
                    onClick={() => window.open(rowData.url, "_blank")}
                >
                    <DownloadIcon size={20} />
                </Box>
            ),
        },
    ];

    return (
        <Box sx={{ p: 2 }}>
            <DataGrid
                dataSource={importHistorys}
                columns={columns}
                height={window.innerHeight - 150}
                filterRow={{
                    enable: true,
                }}
                searchEnable={true}
                exportConfig={{
                    enable: true,
                    fileName: "lich-su-import",
                }}
                paging={{
                    enable: true,
                    pageSize: 50,
                    pageSizeItems: [50, 100, 200, 500],
                }}
                actionComponent={
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <ActionMenu>
                            <ActionMenu.Button leadingVisual={PlusIcon} variant="primary" size="small">
                                Thao tác
                            </ActionMenu.Button>
                            <ActionMenu.Overlay width="auto">
                                <ActionList showDividers>
                                    {/* <ActionList.Item onSelect={handleShowImportKhoanThu}>
                                        <ActionList.LeadingVisual>
                                            <UploadIcon />
                                        </ActionList.LeadingVisual>
                                        <Text>Import khoản thu</Text>
                                    </ActionList.Item> */}
                                    {/* <ActionList.Item onSelect={handleShowImportKhoanNop}>
                                        <ActionList.LeadingVisual>
                                            <UploadIcon />
                                        </ActionList.LeadingVisual>
                                        <Text>Import khoản nộp</Text>
                                    </ActionList.Item> */}
                                    <ActionList.Item onSelect={handleShowImportKhoanNopNew}>
                                        <ActionList.LeadingVisual>
                                            <UploadIcon />
                                        </ActionList.LeadingVisual>
                                        <Text>Import khoản nộp</Text>
                                    </ActionList.Item>
                                    <ActionList.Item onSelect={handleShowImportHoanPhi}>
                                        <ActionList.LeadingVisual>
                                            <UploadIcon />
                                        </ActionList.LeadingVisual>
                                        <Text>Import hoàn phí</Text>
                                    </ActionList.Item>
                                    <ActionList.Item onSelect={handleShowImportQuyetToan}>
                                        <ActionList.LeadingVisual>
                                            <UploadIcon />
                                        </ActionList.LeadingVisual>
                                        <Text>Import quyết toán</Text>
                                    </ActionList.Item>
                                </ActionList>
                            </ActionMenu.Overlay>
                        </ActionMenu>
                        <Button
                            variant="default"
                            size="small"
                            leadingVisual={SyncIcon}
                            onClick={handleRefresh}
                        >
                            Làm mới
                        </Button>
                    </Box>
                }
            />

            {isShowImportKhoanThuModal && (
                <KhoanThuImportModal
                    nam_hoc={param_nam_hoc}
                    dm_coso_id={dm_coso_id}
                    animationOf="#btnImport"
                    onClose={() => {
                        setIsShowImportKhoanThuModal(false);
                        handleRefresh();
                    }}
                    onSuccess={() => {
                        setIsShowImportKhoanThuModal(false);
                        handleRefresh();
                    }}
                />
            )}
            {isShowImportKhoanNopModal && (
                <KhoanNopImportModal
                    nam_hoc={param_nam_hoc}
                    dm_coso_id={dm_coso_id}
                    animationOf="#btnImport"
                    onClose={() => {
                        setIsShowImportKhoanNopModal(false);
                        handleRefresh();
                    }}
                    onSuccess={() => {
                        setIsShowImportKhoanNopModal(false);
                        handleRefresh();
                    }}
                />
            )}
            {isShowImportKhoanNopV3Modal && (
                <KhoanNopImportModalV3
                    nam_hoc={param_nam_hoc}
                    dm_coso_id={dm_coso_id}
                    animationOf="#btnImport"
                    onClose={() => {
                        setIsShowImportKhoanNopV3Modal(false);
                        handleRefresh();
                    }}
                    onSuccess={() => {
                        setIsShowImportKhoanNopV3Modal(false);
                        handleRefresh();
                    }}
                />
            )}
            {isShowImportHoanPhiModal && (
                <HoanPhiImportModal
                    nam_hoc={param_nam_hoc}
                    dm_coso_id={dm_coso_id}
                    animationOf="#btnImport"
                    onClose={() => {
                        setIsShowImportHoanPhiModal(false);
                        handleRefresh();
                    }}
                    onSuccess={() => {
                        setIsShowImportHoanPhiModal(false);
                        handleRefresh();
                    }}
                />
            )}
            {isShowImportQuyetToanModal && (
                <ImportHachToanModal
                    nam_hoc={param_nam_hoc}
                    animationOf="#btnInsert"
                    onClose={() => {
                        setIsShowImportQuyetToanModal(false);
                        handleRefresh();
                    }}
                    onSuccess={() => {
                        setIsShowImportQuyetToanModal(false);
                        handleRefresh();
                    }}
                />
            )}
            {isShowPreview && (
                <DetailModal
                    dataSource={dataPreview}
                    title="Chi tiết"
                    onClose={() => {
                        setIsShowPreview(false);
                        handleRefresh();
                    }}
                />
            )}
            {isShowEditKhoanNopModal && (
                <EditKhoanNopModal
                    request={request}
                    title="Chi tiết import khoản nộp"
                    onClose={() => {
                        setIsShowEditKhoanNopModal(false);
                        handleRefresh();
                    }}
                />
            )}
        </Box>
    );
};

export default ImportHistoryPage;
